const COMPANY = {
  GET_VISITS_CONFIG: 'getConfig' as 'getConfig',
  SET_VISITS_CONFIG: 'saveConfig' as 'saveConfig',
}

export default COMPANY
